const events = {
  collections: {
    search_collections: 'collections:search_collections',
  },
  download_btn: {
    initial_click: 'download_btn:initial_click',
  },
  editor: {
    command: 'commandexec',
    load: 'editor:load',
  },
  modal: {
    close_modal: 'modal:close_modal',
  },
  search: {
    apply_filters: 'search:apply_filters',
    click: 'search:click',
    sponsored_click: 'search:sponsored_click',
    update_content_type: 'search:update_content_type',
  },
  show_page: {
    // start split-test: iscroll_modal
    modal: {
      build_resource_navigation_context: 'show_page:modal:build_resource_navigation_context',
      history_close_modal_view: 'show_page:modal:history_close_modal_view',
      reload_modal_view: 'show_page:modal:reload_modal_view',
      update_resource_navigation_context: 'show_page:modal:update_resource_navigation_context',
    },
    // end split-test: iscroll_modal
    reveal_free_attribution_slidedown: 'show_page:reveal_free_attribution_slidedown',
  },
  turbolinks: {
    load: 'turbolinks:load',
  },
  checkout: {
    error: 'checkout:error',
    new_tax_response: 'checkout:new_tax_response',
    reset_tax: 'checkout:reset_tax',
  },
  util: {
    ez_drop_down: {
      close_drop_down: 'util:ez_drop_down:close_drop_down',
    },
  },
};

export default events;
